export default __webpack_public_path__ + "static/eg-9cf92f299ce8aea1a5771a8d980ac6e9.svg";